// extracted by mini-css-extract-plugin
module.exports = {"formPair":"TextArea_formPair__pVY3M"};